var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.getAuthCode()}}},[_vm._v("Sign in/Log in using Google")])}
var staticRenderFns = []

export { render, staticRenderFns }